import React, { useState, useEffect } from "react";
import { useFont } from "../../contexts/FontContext/FontContext";
import styles from "./MiddleSection.module.css";

const MiddleSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const scrollThreshold = 450; // Set default scroll threshold
  const fontSchemes = useFont();    
  const fontFamilyThree = fontSchemes.scheme_three; 

  useEffect(() => { 
    const handleScroll = () => { const scrollPosition = window.scrollY || window.pageYOffset; if (scrollPosition > scrollThreshold) { setIsVisible(true); } };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll); // Cleanup on unmount
  }, [scrollThreshold]);

  return (
    <div className={styles.middle_section}>
      <div className={styles.middle_section_text_wrapper}>
        <p className={`${styles.middle_section_text} ${fontFamilyThree} ${isVisible ? styles.fade_in : ""}`}>
          Process returns, generate labels, and improve your bottom line while providing your customers with a seamless and convenient experience.
        </p>
      </div>
    </div>
  );
};

export default MiddleSection;
